import ImagePreloader from 'image-preloader';

export default function preloadImages(array){
    let loader = new ImagePreloader()
    return loader.preload.apply(loader, array)
}
